import { Component, Input } from '@angular/core';
import { ChannelStatus } from 'src/app/models/channel';
import { isPending } from '../utility/campaign';
import { environment } from 'src/environments/environment';
import { Campaign } from 'src/app/models/campaign';

@Component({
    selector: 'app-campaign-media-summary-table',
    templateUrl: './campaign-media-summary-table.component.html',
    styleUrls: ['./campaign-media-summary-table.component.scss']
})
export class CampaignMediaSummaryTableComponent {
    @Input() rows;
    @Input() isEditMode: boolean = false;
    @Input() showChannelStatusDistinction: boolean;
    @Input() campaign: Campaign;
    @Input() getChannelStatusForMedia: (
        campaign: Campaign,
        mediaOverviewDTOS: any[]
    ) => ChannelStatus;
    @Input() columns;
    mediaUrl = environment.apiUrl;
    ChannelStatus = ChannelStatus;

    constructor() { }

    isPending(status) {
        return isPending(status);
    }

    shouldAppearTransclusent(mediaStatus, editMode) {
        return mediaStatus != 'DRAFT' && editMode;
    }
}
